import {
  calculateFinances,
  UserData,
  calculateSipFutureValue,
  formatRupeeLiteral,
} from '../../../constants';

const SummaryWhyFD = {
  label: 'Why Invest',
  hide: true,
  sections: [
    {
      type: 'text',
      text: (data: UserData) => {
        const taxData = calculateFinances(data);
        const fdMonthly = Math.round(data.fd / 0.065 / 12 / 1000) * 1000;
        const aggressivePlan = calculateSipFutureValue(fdMonthly, 25, 15);
        return `
        <h5>${
          data.firstName ? `${data.firstName}, ` : ''
        } Make up to Rs. ${formatRupeeLiteral(aggressivePlan)} in ${
          taxData.aggressiveYears
        } Years by investing same amount you invested in Fixed Deposits!</h5>
        <div class="sunshine-block">
          <ul>
            <li><label>Age</label><span>${data.age}</span></li>
            <li><label>Income</label><span>Rs. ${data.income.toLocaleString(
              'en-IN'
            )}</span></li>
            <li><label>Tax Savings</label><span>Rs. ${data.investments80C.toLocaleString(
              'en-IN'
            )}</span></li>
            ${
              data.married
                ? `<li><label>Marital Status</label><span>${
                    data.married
                  }</span></li>`
                : ''
            }
            ${
              data.fd
                ? `<li><label>FD Interest</label><span>Rs. ${data.fd.toLocaleString(
                    'en-IN'
                  )}</span></li>`
                : ''
            }
            ${
              data.deduction80DInsurance
                ? `<li><label>Health Insurance</label><span>Rs. ${data.deduction80DInsurance.toLocaleString(
                    'en-IN'
                  )}</span></li>`
                : ''
            }
            ${
              data.homeLoan
                ? `<li><label>Home Ownership</label><span>${
                    data.homeLoan
                  }</span></li>`
                : ''
            }
          </ul>
          <div class="analysis">
            We analyzed your data<br/>
            and can help you<br />
            grow your money up to<br/>
            <span>Rs. ${formatRupeeLiteral(aggressivePlan)}</span><br />
          </div>
        </div>
        `;
      },
    },
  ],
};

export default SummaryWhyFD;



// WEBPACK FOOTER //
// ./components/recommendation/cards/summaryWhyFD.ts